<div class="mfa-modal-overlay" *ngIf="isVisible">
  <div class="mfa-modal-content" (click)="stopPropagation($event)">

    <div class="mfa-modal-header-fixed">
      <h3 class="mfa-modal-title">{{ translate('title') }}</h3>
      <p class="mfa-description">{{ translate('description') }}</p>
    </div>
    
    <div class="mfa-steps-scrollable">
      <div class="mfa-steps-container">
      <div class="mfa-step-container">
        <div >
          <span class="step-number">1. </span>
          <span class="step-text">{{ translate('step1') }} 
            <b>Microsoft Authenticator</b></span>
          <p class="step-text step-text-secondary" style="margin-top: 8px; margin-left: 0;">{{ translate('step1Secondary') }}</p>
        </div>
        <div class="store-app-container">
            <img class="authenticator-icon" src="./assets/img/authenticator.svg" alt="Microsoft Authenticator">
          <div >
            <p>{{ translate('downloadAppStore') }}</p>
            <a href="https://apps.apple.com/app/microsoft-authenticator/id983156458" target="_blank" rel="noopener noreferrer">
              <img class="appstore-link-img" src="./assets/img/appstore-download.svg" alt="App Store Download">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" rel="noopener noreferrer">
              <img class="playstore-link-img" src="./assets/img/playstore-download.svg" alt="Play Store Download">
            </a>
          </div>
        </div>
      </div>

      <div class="mfa-step-container">
        <div style="width: 100%;">
          <div>
            <span class="step-number">2. </span>
            <span class="step-text">{{ translate('step2') }}</span>
          </div>
          <div class="qr-section">
            <div>
              <div class="qr-code-container" *ngIf="qrCodeUrl" (click)="onClickEnrollMFA()">
                <img [src]="qrCodeUrl" alt="QR Code" class="qr-code-image">
              </div>
              <div class="qr-code-container" *ngIf="!qrCodeUrl && isLoading">
                <div class="qr-loading">{{ translate('loadingQR') }}</div>
              </div>
              <div class="qr-code-container qr-error-container" *ngIf="!qrCodeUrl && !isLoading && showRetryButton">
                <div class="qr-error-content">
                  <p class="qr-error-message">{{ translate('qrError') }}</p>
                  <button 
                    class="kl-btn btn-primary qr-retry-button" 
                    (click)="onClickEnrollMFA()"
                    [disabled]="isLoading"
                  >
                    <span *ngIf="!isLoading">{{ translate('getAccess') }}</span>
                    <span *ngIf="isLoading">{{ translate('loading') }}</span>
                  </button>
                </div>
              </div>
            </div>
            
            <div class="manual-code-section">
              <p class="manual-code-question">{{ translate('cannotScanQR') }}</p>
              <p class="manual-code-label">{{ translate('copyCode') }}</p>
              <div class="manual-code-input-container">
                <input 
                  type="text" 
                  [value]="secretCode" 
                  readonly 
                  class="manual-code-input"
                  #secretInput
                >
                <button 
                  class="copy-button" 
                  (click)="copySecretCode(secretInput)"
                  [attr.aria-label]="translate('copyButton')"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mfa-step-container">
        <div style="width: 100%;">
          <div>
            <span class="step-number">3. </span>
            <span class="step-text">{{ translate('step3') }}</span>
          </div>
          <div class="verification-code-section">
            <input 
              type="text" 
              [(ngModel)]="verificationCode"
              [placeholder]="translate('codePlaceholder')"
              class="verification-code-input"
              maxlength="6"
              (input)="onCodeInput($event)"
              [disabled]="isVerifying || isMfaConfigured"
            >
            <div class="error-message" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>
            <div class="success-message" *ngIf="successMessage">
              {{ successMessage }}
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="mfa-understood-btn-container">
      <div class="language-selector-container">
        <select 
          class="language-selector" 
          [value]="currentLanguage"
          (change)="changeLanguage($any($event.target).value)"
        >
          <option *ngFor="let lang of languages" [value]="lang.code">
            {{ lang.label }}
          </option>
        </select>
      </div>
      <div class="mfa-buttons-wrapper">
        <button 
          class="mfa-remind-later-btn" 
          (click)="handleRemindLater()"
          [disabled]="isVerifying || isEnrolling"
        >
          {{ translate('remindLater') }}
        </button>
        <button 
          class="mfa-understood-btn" 
          (click)="handleReady()"
          [disabled]="!isMfaConfigured || isVerifying || isEnrolling"
        >
          {{ translate('ready') }}
        </button>
      </div>
    </div>
  </div>
</div>

